// 后台发送测试的接口（docs/04 第 11 节，决策 D94）。
import { api } from "./api";
import { auditCount, auditList } from "./audit";

/** 测试对象：按通道用系统测试账号直接发给指定通道、不计费；按账号以该账号的身份走正常路由、照常计费。 */
export type TestTarget = "channel" | "account";

export interface TestSendInput { target: TestTarget; channel_id?: number; account_id?: number; to: string; sender: string; text: string }

export const testSend = {
  /** 系统测试账号与客户的 id：主数据列表里没有它们（决策 D94）。 */
  system: () => api<{ account_id: number; customer_id: number }>("/test-send/system"),
  /** 所有人发过的测试，即 message 实体的审计记录，按游标倒序翻页；系统管理员读不了审计也能看（D181）。 */
  history: (f: { limit?: number; before_id?: number }) => auditList("/test-send/history", f),
  /** 发过的测试的总数（决策 D182）。 */
  historyCount: () => auditCount("/test-send/history"),
  send: (body: TestSendInput) => api<{ message_id: string }>("/test-send", { method: "POST", body: JSON.stringify(body) }),
};
